export const MASKED_VALUE = '—';

export const VIEW_ONLY_ROLE_NAME = 'view-only';

export function isViewOnlyRoleName(name) {
  return (name || '').trim().toLowerCase() === VIEW_ONLY_ROLE_NAME;
}

export function getRoleRecordId(role) {
  return role?.roleId || role?.id || null;
}

export function getUserRoleId(user) {
  if (!user) return null;
  return user.roleId || user.user_metadata?.roleId || user.app_metadata?.roleId || null;
}

export function findRoleById(roles, roleId) {
  if (!roleId || !Array.isArray(roles)) return null;
  return roles.find((role) => getRoleRecordId(role) === roleId) || null;
}

export function buildPermissionsFromRole(role) {
  if (!role) {
    return fullAccessPermissions();
  }

  const viewOnly =
    isViewOnlyRoleName(role.name) ||
    role.type === 'view-only' ||
    role.isViewOnly === true;

  if (!viewOnly) {
    return fullAccessPermissions();
  }

  return {
    isViewOnly: true,
    canCreateEntity: false,
    canEditEntity: false,
    canUploadDocuments: false,
    canAddNotes: false,
    canRequestCreditLimit: false,
    canApprove: false,
    canViewFinancialData: role.can_view_financial_data !== false,
    canDownloadReports: role.can_download_reports === true,
    canSendMitigationRequest: false,
    canRequestManualEvaluation: false,
    canDeleteEntity: false,
    canVerifyEntity: false,
  };
}

export function fullAccessPermissions() {
  return {
    isViewOnly: false,
    canCreateEntity: true,
    canEditEntity: true,
    canUploadDocuments: true,
    canAddNotes: true,
    canRequestCreditLimit: true,
    canApprove: true,
    canViewFinancialData: true,
    canDownloadReports: true,
    canSendMitigationRequest: true,
    canRequestManualEvaluation: true,
    canDeleteEntity: true,
    canVerifyEntity: true,
  };
}

export function maskIfNeeded(value, canView) {
  if (canView) return value;
  if (value === undefined || value === null || value === '') return value;
  return MASKED_VALUE;
}
